import src from "./buzzfeed.svg";
export default { src: src, aspect: 5.2631578947368425, width: 100, height: 19 };